import * as Diff from 'diff';
import { createLog } from '@/services/serviceAuditLogs';

export function zistiDiff(oldStr, newStr, id, type){
    const finalObj = { ...oldStr, ...newStr };
    let diffs = {};

    for (const keyDoc of Object.keys(finalObj)) {
        
        if(checkFields(keyDoc, type)){
            let x = '';
            if(keyDoc==='components'){
                x = getDiff(JSON.stringify(oldStr[keyDoc]), JSON.stringify(newStr[keyDoc]))
            }else{
                x = getDiff(String(oldStr[keyDoc]), String(newStr[keyDoc]))
            }
            diffs[keyDoc]= x;
            x = '';
        }
    }

    const dataToStore = {id,type,diffs}
    createLog({data:dataToStore}).then(response => {
        if(!response.statusText){
            console.log(response)
        }
    })
}

function getDiff(oldStr, newStr){
    return Diff.diffWordsWithSpace(oldStr, newStr).map((value) => {
        if (!value.added && !value.removed) {
        const startIndex = newStr.indexOf(value.value);
        return { start: startIndex, end: startIndex + value.value.length };
        }
        return value;
    });
}

export function checkFields(key, type){
    const articleFields = ['components','id','title','alias','subTitle','category','color_background_title','color_text_title','created','modified','external_url','full_text','language','param_show_date_created_isActive','param_show_date_modified_isActive','photo','photoSeo','publish_down','publish_up','short_text','state','url_logo_brand','selected'];

    const userFields = ["id","name","surname","username","titleBefore","titleAfter","email","phone","street","country","region","district","city","active","type","state","multi","color","valid_up","valid_down","access","access_name","created","modified","isAllowedSetMultiLogin"];

    if(type===2){
        if(articleFields.includes(key)) {return true;}
    }else if(type===1){
        if(userFields.includes(key)) {return true;}
    }
    return false;
}